import { css } from '@emotion/react'

const paneGroup = css`
  min-height: 0;
  @media print {
    min-width: 0 !important;
  }
`

export const styles = {
  paneGroup,
}
